import "./App.css";
import Map from "./components/Map";

// const NavBar = styled.ul`
//   display: flex;
//   width: 100%;
//   justify-contents: space-evenly;
// `;

function App() {
  return (
    <div className="App">
      <Map />
    </div>
  );
}

export default App;

//http://192.168.1.217:3000
